import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform(value: any[], order = "", field: string = ""): any[] {
    if (order === "asc") {
      return value.sort((a, b) => {
        if (this.toLowerCase(a[field]) < this.toLowerCase(b[field]))
          return -1;
        if (this.toLowerCase(a[field]) > this.toLowerCase(b[field]))
          return 1;
        return 0;
      }).concat([]);
    } else {
      return value.sort((a, b) => {
        if (this.toLowerCase(a[field]) < this.toLowerCase(b[field]))
          return 1;
        if (this.toLowerCase(a[field]) > this.toLowerCase(b[field]))
          return -1;
        return 0;
      }).concat([]);
    }
  }

  private toLowerCase(value: any) {
    if (typeof value == "string") {
      return value.toLowerCase();
    }

    return value;
  }

}
